// check if two objects are dates and equal
export function dateEquals(obj1: unknown, obj2: unknown): boolean {
    if (obj1 instanceof Date && obj2 instanceof Date) {
        return obj1.getTime() == obj2.getTime();
    }
    return false;
}